var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as cn from "classnames";
import * as React from "react";
import { AdLabel } from "./adLabel";
import * as styles from "./styles.css";
export var AdBounded = function (_a) {
    var children = _a.children, className = _a.className, rest = __rest(_a, ["children", "className"]);
    return (React.createElement("div", __assign({}, rest, { className: cn(styles.ad, styles.adBounded, className) }),
        React.createElement(AdLabel, null, "Advertisement"),
        children));
};



//////////////////
// WEBPACK FOOTER
// ./app/shared/components/ad/adBounded.tsx
// module id = trvs
// module chunks = 2